import { Button, IconButton } from '@mui/material';
import React from 'react';

const classes = {
	buttonDesktop: {
		display: { xs: 'none', xsm: 'none', md: 'inherit' },
		padding: '5px 15px',
		fontSize: '0.875rem',
	},
	buttonMobile: { display: { sm: 'block', md: 'none' } },
};

const ResponsiveButton = ({
	startIcon,
	onClick,
	dataTestId,
	styleDesktop,
	styleMobile,
	ariaLabel,
	buttonTitle,
	variant,
}) => (
	<>
		<Button
			variant={variant}
			startIcon={startIcon}
			onClick={onClick}
			size="small"
			data-testid={dataTestId}
			sx={{ ...classes.buttonDesktop, ...styleDesktop }}
		>
			{buttonTitle}
		</Button>
		<IconButton
			onClick={onClick}
			sx={{ ...classes.buttonMobile, ...styleMobile }}
			title={buttonTitle}
			color="primary"
			data-testid={`${dataTestId}-icon`}
			aria-label={ariaLabel}
		>
			{startIcon}
		</IconButton>
	</>
);

export default ResponsiveButton;
